import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["delta"],
  _excluded2 = ["delta"];
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import * as ChronoUnit from 'automation-ui-flow-core/fields/time/ChronoUnit';
import TimeDelta from 'automation-ui-flow-core/fields/time/TimeDelta';
export default class EnrollmentDateProperty extends createImmutableObjectClass({
  propertyName: '',
  delta: {
    delta: 0,
    timeUnit: ChronoUnit.DAYS
  }
}, {
  fromJSON: _ref => {
    let {
        delta
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({
      delta: new TimeDelta(delta)
    }, rest);
  },
  toJSON: _ref2 => {
    let {
        delta
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return Object.assign({
      delta: delta.toJSON()
    }, rest);
  }
}) {
  setTimeDelta(timeDelta) {
    return this.set('delta', timeDelta);
  }
}